import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const PageContainer = styled.div`
  min-height: 100vh;
  padding: 40px 0;

  ${theme.breakpoints.down('md')} {
    padding: 16px;
    padding-bottom: 220px;
    // background: #EFF3FE;
  }
`

export const PageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 32px;
  align-items: start;

  ${theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    gap: 16px;
    display: flex;
    flex-direction: column;
  }
`

export const ContentCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;

  ${theme.breakpoints.down('md')} {
    padding: 16px;
    border-radius: 0;
    margin-left: -24px;
    margin-right: -16px;
    width: calc(100% + 8px);
  }
`

export const PageTitle = styled.h1`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0px;
  margin: 0 0 8px 0;
  color: #1f2937;

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`

export const MobilePageTitle = styled.h1`
  display: none;

  ${theme.breakpoints.down('md')} {
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #262626;
    margin: 0 0 16px 0;
    order: -2;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: 32px;

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`

export const Placeholder = styled.div`
  border: 1px dashed #c7d2fe;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  background: #f9fafb;
  margin-top: 16px;
`

export const PlaceholderTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #1f2937;
`

export const PlaceholderText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e5e7eb;
  margin: 24px 0;

  ${theme.breakpoints.down('md')} {
    background: #e6e6e6;
  }
`

export const AgreementDescription = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #666666;
  margin: 0;
`

export const AgreementSummary = styled.div`
  margin-top: 24px;
`

export const SummarySection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #9ca3af;
  margin: 0 0 16px 0;
`

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
`

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
  text-align: right;
`

export const SummaryDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #e5e7eb;
  margin: 24px 0;
`

export const InstallmentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const InstallmentLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
`

export const InstallmentValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
`

export const InstallmentDate = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
`

export const InstallmentRightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const ViewAllLink = styled.a`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #2563eb;
  text-decoration: none;
  cursor: pointer;
  margin-top: 12px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`

export const TotalPaidHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 24px;
`

export const TotalPaidLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #1f2937;
`

export const TotalPaidValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #1f2937;
`

export const ImportantBanner = styled.div`
  background: #fce4cf;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

export const WarningIconWrapper = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ImportantContent = styled.div`
  flex: 1;
`

export const ImportantTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
  margin-bottom: 4px;
`

export const ImportantText = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
`

export const SignButton = styled.button`
  width: 100%;
  background: #2563eb;
  border: none;
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  margin-bottom: 12px;
  transition: background-color 0.2s;

  &:hover {
    background: #1d4ed8;
  }

  &:active {
    background: #1e40af;
  }
`

export const SignButtonIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SignButtonText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
`

export const DisclaimerText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #1f2937;
  margin: 0;
  text-align: center;
`

export const DisclaimerLink = styled.a`
  color: #1f2937;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #2563eb;
  }
`

export const AwaitingHeader = styled.div`
  display: flex;
  align-items: center;
  background: #999999;
  border-radius: 12px 12px 0 0;
  padding: 16px 40px;
  margin: -40px -40px 24px -40px;
  color: #fff;

  ${theme.breakpoints.down('md')} {
    margin: -24px -24px 16px -24px;
    padding: 16px 24px;
  }
`

export const AwaitingHeaderIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`

export const AwaitingHeaderText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`

export const AwaitingDescription = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #666666;
  margin: 0 0 24px 0;
`

export const AwaitingSectionTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #999999;
  margin: 0 0 16px 0;
`

export const SignaturesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
`

export const SignatureColumn = styled.div`
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 8px;
  padding: 16px;
`

export const SignatureHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const SignatureTitle = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #1f2937;
`

export const SignatureStatus = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: ${props => (props.variant === 'success' ? '#065F46' : '#92400E')};
  background: ${props => (props.variant === 'success' ? '#D1FAE5' : '#FDE68A')};
  padding: 4px 12px;
  border-radius: 999px;
`

export const SignatureInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SignatureName = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #111827;
`

export const SignatureDetail = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #4b5563;
`

export const InfoNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #dbeafe;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`

export const InfoIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #cceeff;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InfoNoteText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
  margin: 0;
`

export const SupportText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #4b5563;
  text-align: center;
`

export const SupportLink = styled.a`
  color: #2563eb;
  text-decoration: underline;
  cursor: pointer;
`

export const ProcessingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
`

export const ProcessingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 80px 0 0 0;
`

export const ProcessingIconWrapper = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const ProcessingText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #666666;
  margin: 0;
  text-align: center;
`
